import * as Long from "long";
import { ofType } from "redux-observable";
import { concat, from, of } from "rxjs";
import { filter, mapTo, switchMap, take } from "rxjs/operators";
import { IdResource } from "../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../selectors/selectInventoryInfo";
import { selectNotEnoughResourcesMissingResources } from "../../../selectors/selectNotEnoughResources";
import { actionBeginBuyWithGoldProcess } from "../../buy-with-gold/actionBuyWithGold";
import { actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../ongoing-purchase/actionOngoingPurchase";
import { actionBuyImprovementRequest, TypeActionImprovement, } from "../actionImprovement";
export var epicBuyImprovement = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionImprovement.Buy), switchMap(function (action) {
        var state = state$.value;
        var id = action.id, cost = action.cost, buildingId = action.buildingId, premium = action.premium;
        var playerGoldInfo = selectInventoryResourceInfo(state, IdResource.Gold);
        var missingResources = selectNotEnoughResourcesMissingResources(state, cost);
        if (premium) {
            var goldRequired = cost[0].amount || Long.ZERO;
            var playerGold = playerGoldInfo.amount || Long.ZERO;
            return of(actionBeginBuyWithGoldProcess(playerGold, goldRequired, actionBuyImprovementRequest(id, cost, buildingId, premium)));
        }
        else if (missingResources.length > 0) {
            return concat(from([
                actionOngoingPurchaseStandardSelect([
                    {
                        missingResources: missingResources,
                        missingType: IdMissingResourceTypes.Resources,
                    },
                ]),
                actionModalOpen(IdModal.NotEnoughResource),
            ]), action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), take(1), filter(function (notEnoughResourceAction$) {
                return notEnoughResourceAction$.isPurchased;
            }), mapTo(actionBuyImprovementRequest(id, cost, buildingId, premium))));
        }
        return of(actionBuyImprovementRequest(id, cost, buildingId, premium));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/epics/epicBuyImprovement.ts
// module id = 1894
// module chunks = 3